import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/all";
import { ScrollTrigger } from "gsap/all";

const AnchorBtnBack = document.querySelector(".inside-page-back");

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

  let smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper-inside",
    content: "#smooth-content-inside",
    smooth: 2,
    smoothTouch: 0.1,
  });
});

AnchorBtnBack.addEventListener("click", function (e) {
  e.preventDefault();
  history.back();
});
